import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { RuleInterface, StringEquals } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AutomationViewService } from '../../../../../automation/automation-view.service';
import { AutomationReplacementChipsComponent } from '../../../../../common/components/automation-replacement-chips/automation-replacement-chips.component';
import { ActionListsSelectorService } from '../../../../../data-services/action-lists-selector-service';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';

@Component({
  templateUrl: './added-to-list-panel.component.html',
  styleUrls: ['./added-to-list-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationReplacementChipsComponent,
  ],
})
export class AddedToListPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  actionListsSelectorService = inject(ActionListsSelectorService);
  actionListNameControl: UntypedFormControl = new UntypedFormControl('');

  constructor(protected readonly automationService: AutomationViewService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.actionListNameControl.setValue(
      this.triggerChoices?.rules[0]?.value ? JSON.parse(this.triggerChoices?.rules[0]?.value) : '',
    );
  }

  finishedLoadingSelector(): void {
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.actionListNameControl];
  }

  isFormValid(): boolean {
    return !this.actionListNameControl.invalid;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return [new StringEquals('{.action_list_name}', '', '').toRuleInterface()];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    rules[0].value = JSON.stringify(this.actionListNameControl.value);
    return rules;
  }
}
